module.exports = __webpack_public_path__ + "static/media/navbarlogo.876106a8.png";